<template>
    <div class='outer-container'>
        <div class='create-review-container' v-show='!review_submitted'>
            <h3 class='title'>Leave a review</h3>
            <div class='rating-container'>
                <p class='label'>Your rating</p>
                <star-rating :star-size="20" inactive-color="#95A5A6" active-color="#293533" v-model:rating="review.rating" @update:rating ="setRating"/>
            </div>
            <p class='error' v-show='errors.rating'>{{errors.rating}}</p>
            <div class='rating-container'>
                <p class='label'>Would you buy it again?</p>
                <button class='buy-it-again-button' :class="{'active-button' : review.buy_again === 1}" @click='buyAgain(1)'>Yes</button>
                <button class='buy-it-again-button' :class="{'active-button' : review.buy_again === 0}" @click='buyAgain(0)'>No</button>
            </div>
            <p class='error' v-show='errors.buy_again'>{{errors.buy_again}}</p>
            <div>
                <Field id='review' label="Review (optional)" :errors='errors' >
                    <textarea class="review-textarea" autocomplete="off" v-model='review.review'/>
                </Field>
            </div>
            <div>
                <CheckBox id='hide_name_checkbox' label="Hide my name" @checkBoxListener='setHideName'/>
            </div>

            <Button class='post-review-button' text='Post review' theme='dark' @click='saveReview'/>
            <p class='google-recaptcha-text'>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
            <p class='error' v-show='errors.rating'>{{errors.recaptcha}}</p>

        </div>
        <div v-show='review_submitted'>
            <h2 class='success-message'> Thanks - your review has been submitted.</h2>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import Field from '@/ecom/components/fields/Field.vue';
import Button from '@/ecom/components/buttons/Button.vue';
import StarRating from 'vue-star-rating';
import CheckBox from '@/ecom/components/fields/CheckBox.vue';
import { load } from 'recaptcha-v3'

export default {
    components: {Field, Button, StarRating, CheckBox},
    props: ['product_id', 'product_on_popout', 'logged_in'],
    emits: ['reviewCreatedListener'],
    data(){
        return{
            errors: {},
            review:{
                rating: 0,
                buy_again: '',
                review: '',
                show_name: 1
            },
            review_submitted: false,
            recaptcha: null
        }
    },
    methods:{
        async saveReview() {
            const token = await this.recaptcha.execute('submit');

            let response = await fetch('/api/user-review', {
                method: 'POST',
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    review : this.review,
                    product_id: this.product_id,
                    token: token
                }),
            });

            let results = await checkAuth(response);
            if (response.status === 200) {
                if(results.errors.length === 0) {
                    this.review_submitted = true;
                    this.$emit('reviewCreatedListener');
                } 
                else {
                    this.errors = results.errors;
                }
            }
        },
        buyAgain(type){
            this.review.buy_again = type;
        },
        setHideName(id, value){
            this.review.show_name = !value;
        },
        setRating(){

        },
        async getRecaptchaClientKey(){
            const response = await fetch("/api/captcha-client-key", {
                method: "GET",
                credentials: "include"
            });

            let results = await response.json();

            if (response.status === 200) {
                let recaptcha_client_key = results;

                this.recaptcha = await load(recaptcha_client_key,{
                    autoHideBadge: true //If hiding badge, have to include the reCAPTCHA branding visibly in the user flow as per google T&C's.
                });
            }
        }
    },
    beforeMount(){
        if(!this.product_on_popout){
            this.getRecaptchaClientKey();
        }
    }
}
</script>

<style lang="scss" scoped>

.outer-container{
    width: 100%;
}

.create-review-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.title{
    font-size: 1.8rem;
    color: var(--black);
    font-weight: 400;
    text-align: center;
}

.rating-container{
    display: flex;
    gap: 16px;
    align-items: center;
}

.buy-it-again-button{
    background-color: white;
    border-radius: 8px;
    padding: 0px 24px;
    width: 80px;
    height: 40px;
    border: 1px solid var(--black);
    cursor: pointer;
}
.buy-it-again-button.active-button{
    background-color: var(--black);
    color: white;
}

.review-textarea{
    border: 1px solid var(--black);
    border-radius: 8px;
    width: 100%;
    min-height: 200px;
}

.post-review-button{
    max-width: 200px;
}
.label{
    font-size: 1rem;
    color: var(--black);
    font-weight: 600;
}

.error{
    color: red;
    margin: 0;
}


.success-message{
    text-align: center;
}

.google-recaptcha-text{
    font-size: 0.7rem;
    margin: 0;
}

</style>